import {
  createTRPCContext,
  TRPCInfiniteQueryOptions,
  TRPCMutationOptions,
  TRPCQueryOptions,
  TRPCSubscriptionOptions,
} from '@trpc/tanstack-react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { TRPCAPIRouter } from '../../../music24-api/src/trpc/router';

export const useTRPCQuery = useQuery;
export const useTRPCMutation = useMutation;

export const {
  TRPCProvider: TRPCProviderAPI,
  useTRPC: useTRPCAPI,
  useTRPCClient: useTRPCClientAPI,
} = createTRPCContext<TRPCAPIRouter>();

export type TRPCTypeAPI = ReturnType<typeof useTRPCAPI>;
export type RequiredProperties<T, P extends keyof T> = Omit<T, P> & Required<Pick<T, P>>;
export type UnwrappedAsyncIterable<T> = T extends AsyncIterable<infer U> ? U : never;
export type UnwrappedTRPCSubscriptionOptions<T> = T extends TRPCSubscriptionOptions<infer U> ? U : never;
export type UnwrappedTRPCMutationOptions<T> = T extends TRPCMutationOptions<infer U> ? U : never;
export type UnwrappedTRPCInfiniteQueryOptions<T> = T extends TRPCInfiniteQueryOptions<infer U> ? U : never;
export type UnwrappedTRPCQueryOptions<T> = T extends TRPCQueryOptions<infer U> ? U : never;
